module.exports = require("@material-ui/core/CardContent");